// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__-8-7K","dragIcon":"SortableItem_dragIcon__Sydt4","disabled":"SortableItem_disabled__24QA6"};